import { useTranslation } from '@input-web/configs/locale/locale.config';
import standardStore, { useStandardStore } from '@input-web/modules/standard/stores/standard.store';
import { DialogProps } from '@ui/components/molecules/dialog/dialog.molecule';
import { useMemo } from 'react';

export default function useStandardDialog() {
  // #region Dependencies
  const { confirmationDialogProps } = useStandardStore();
  const { t } = useTranslation();
  // #endregion

  return useMemo<DialogProps>(() => {
    const onClose = () => standardStore.actions.setConfirmationDialogProps({ open: false });
    const { onConfirm, onDecline, ...rest } = confirmationDialogProps ?? {};

    return {
      content: t('standard.layout.dialog.leave-form-content'),
      title: t('standard.layout.dialog.title'),
      ...rest,
      actions: [
        {
          label: t('label.yes'),
          onClick: () => {
            onClose();
            onConfirm?.();
          },
        },
        {
          label: t('label.no'),
          onClick: () => {
            onClose();
            onDecline?.();
          },
        },
      ],
      onClose,
    } as DialogProps;
  }, [confirmationDialogProps, t]);
}
